import { render, staticRenderFns } from "./SimpleLogo.vue?vue&type=template&id=2ff40b93&scoped=true&"
import script from "./SimpleLogo.vue?vue&type=script&lang=js&"
export * from "./SimpleLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff40b93",
  null
  
)

export default component.exports